{
    "Accessibility menu": "Meni pristupačnosti",
    "Close": "Zatvori",
    "Content adjustments": "Prilagođavanja sadržaja",
    "Navigation adjustments": "Prilagođavanja navigacije",
    "Text Align": "Poravnanje teksta",
    "Align Left": "Poravnaj levo",
    "Align Center": "Poravnaj po sredini",
    "Align Right": "Poravnaj desno",
    "Adjust Font Size": "Podesi veličinu fonta",
    "Highlight Title": "Istakni naslov",
    "Highlight Links": "Istakni linkove",
    "Readable Font": "Čitljiv font",
    "Colour adjustments": "Prilagođavanja boja",
    "Dark Contrast": "Tamni kontrast",
    "Light Contrast": "Svetli kontrast",
    "High Contrast": "Visoki kontrast",
    "High Saturation": "Visoka zasićenost",
    "Low Saturation": "Niska zasićenost",
    "Monochrome": "Monohromatski",
    "Tools": "Alati",
    "Reading Guide": "Vodič za čitanje",
    "Big Cursor": "Veliki kursor",
    "Increase Font Size": "Povećaj veličinu fonta",
    "Decrease Font Size": "Smanji veličinu fonta",
    "Letter Spacing": "Razmak između slova",
    "Line Height": "Visina linije",
    "Font Weight": "Debljina fonta",
    "Dyslexia Font": "Font za disleksiju",
    "Language": "Jezik",
    "Accessibility widget": "Otvori meni pristupačnosti",
    "Accessibility Profiles": "Profili pristupačnosti",
    "Cognitive Disability": "Kognitivna invalidnost",
    "Seizure Safe": "Bezbedno za napade",
    "Accessibility statement": "Izjava o pristupačnosti",
    "ADHD": "ADHD",
    "Low Vision": "Slab vid",
    "Pause Animations": "Zaustavi animacije",
    "Animation paused": "Animacija je pauzirana",
    "Reset all settings": "Resetuj podešavanja",
    "Shortcut:": "Prečica:",
    "Epilepsy Safe Mode": "Režim bezbedan za epilepsiju",
    "Mute sounds": "Isključi zvukove",
    "Page read": "Čitanje stranice",
    "Page read controls": "Kontrole čitanja stranice",
    "Pause": "Pauziraj",
    "Resume": "Nastavi",
    "Stop": "Zaustavi",
    "Settings": "Podešavanja",
    "Speed": "Brzina",
    "Voice": "Glas",
    "Close accessibility menu": "Zatvori meni pristupačnosti",
    "Back to accessibility menu": "Nazad na meni pristupačnosti",
    "Search languages": "Pretraži jezike",
    "Selected language": "Izabrani jezik",
    "View accessibility statement (opens in new window)": "Prikaži izjavu o pristupačnosti (otvara se u novom prozoru)",
    "Visit CookieYes website (opens in new window)": "Posetite veb-sajt CookieYes (otvara se u novom prozoru)",
    "Reset all accessibility settings to default": "Vrati sva podešavanja pristupačnosti na podrazumevana"
}
